import { PlanLinkPreview, RedeemPlanLinkResult } from '../types';
import { attachAuthInterceptor } from './authToken';
import axios from 'axios';

const BASE_URL = (process.env.REACT_APP_CLUBHOUSE_API_URL || 'http://localhost:5000').replace(/\/+$/, '');

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});
attachAuthInterceptor(apiClient);

/**
 * Redemption of ProShop plan links. A golfer opens a link they were given, previews the plan,
 * then redeems the token for their signed-in account — attaching their subscription to the plan
 * and adding its prepaid Caddie Credits.
 */
export const redemptionApi = {
  /** Previews a plan link (plan name, credits, whether it's used/expired), or `null` when unknown. */
  preview: async (token: string): Promise<PlanLinkPreview | null> => {
    try {
      const { data } = await apiClient.get<PlanLinkPreview>(`/redemptions/${encodeURIComponent(token)}`);
      return data;
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 404) return null;
      throw err;
    }
  },

  /** Redeems a plan link for the signed-in golfer. */
  redeem: async (token: string, userId: string, email?: string | null): Promise<RedeemPlanLinkResult> => {
    try {
      const { data } = await apiClient.post<RedeemPlanLinkResult>(
        `/redemptions/${encodeURIComponent(token)}`,
        { userId, email: email ?? null },
      );
      return data;
    } catch (err) {
      // The API returns 400 with a RedeemPlanLinkResult body for invalid/used/expired links.
      if (axios.isAxiosError(err) && err.response?.status === 400 && err.response.data) {
        return err.response.data as RedeemPlanLinkResult;
      }
      throw err;
    }
  },
};
